import React, { useEffect } from "react";
import { Box, Flex, FormLabel, Heading } from "@chakra-ui/react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { closeCreateLectureModel } from "../../../../modules/admin-modules/models/Actions";
import MainModel from "../../../../components/Models/main-model";
import { useForm } from "react-hook-form";
import MainInput from "../../../../components/Form/input";
import Select from "react-select";
import { getAllGroupsRequest } from "../../../../modules/admin-modules/groups/Actions";
import { getAllSubjectsRequest } from "../../../../modules/admin-modules/subjects/Actions";
import {
  createLectureRequest,
  editLectureRequest,
} from "../../../../modules/admin-modules/lectures/Actions";
const AddLecture = ({ isAdd, data, setSelectedData, selectedSubjectId }) => {
  const openLecture = useSelector((state) => state.model.isOpen12);
  const groups = useSelector((state) => state.groups.groups);
  const subjects = useSelector((state) => state.subjects.subjects);
  const isLoading = useSelector((state) => state.lectures.isLoading);
  const user = useSelector((state) => state.user.userData);
  const isSuperAdmin = user?.role && user.role[0]?.name === "Super Admin";

  const groupsOptions = groups?.map((data) => {
    return { value: data.id, label: data.name };
  });
  const subjectsOptions = subjects?.map((data) => {
    return { value: data.id, label: data.name };
  });
  const dispatch = useDispatch();
  const colourStyles = {
    control: (styles) => ({
      ...styles,
      width: "100%",
      background: "#f5f5f5",
      color: "#690000",
      borderRadius: "16px",
    }),
    option: (styles) => ({ ...styles, color: "#690000" }),
  };

  const {
    register,
    handleSubmit,
    setValue,
    watch,
    formState: { errors },
    reset,
    getValues,
  } = useForm({
    defaultValues: data ? data : {},
    shouldUnregister: true,
  });

  useEffect(() => {
    if (openLecture) {
      const subjectQuery = selectedSubjectId
        ? { subject_id: selectedSubjectId }
        : {};
      dispatch(getAllGroupsRequest(subjectQuery));
      dispatch(getAllSubjectsRequest());
      if (selectedSubjectId) {
        setValue("subject_id", selectedSubjectId);
      }
    }
  }, [openLecture, selectedSubjectId, dispatch, setValue]);

  const selectedFormSubjectId = watch("subject_id") || selectedSubjectId || data?.subject_id;

  const header = (
    <Box>
      <Heading textAlign="center" color="main_1" fontSize="24px">
        {isAdd ? " إضافة سنتر" : "تعديل  سنتر"}
      </Heading>
    </Box>
  );
  const onSubmit = async (values) => {
    let formData = await new FormData();
    
    // Filter out unwanted fields
    const { subject, edit, date, attendance_count, ...filteredValues } = values;
    
    for (let key in filteredValues) {
      if (key == "groups") {
        // Handle groups array properly
        if (Array.isArray(filteredValues[key])) {
          filteredValues[key].forEach((val, idx) => {
            // If val is an object with id, use the id, otherwise use the value directly
            const groupValue = typeof val === 'object' && val.id ? val.id : val;
            formData.append(`groups[${idx}]`, groupValue);
          });
        }
      } else {
        formData.append(key, filteredValues[key]);
      }
    }
    
    const action = () => {
      dispatch(closeCreateLectureModel());
      setSelectedData({});
      reset();
    };
    
    if (isAdd) {
      await dispatch(createLectureRequest(formData, action));
    } else {
      const totel = { ...data, ...filteredValues };
      
      // Clear formData and rebuild it
      formData = new FormData();
      
      for (let key in totel) {
        if (key == "groups") {
          if (Array.isArray(totel[key])) {
            totel[key].forEach((val, idx) => {
              const groupValue = typeof val === 'object' && val.id ? val.id : val;
              formData.append(`groups[${idx}]`, groupValue);
            });
          }
        } else {
          formData.append(key, totel[key]);
        }
      }
      formData.append("_method", "PUT");

      dispatch(
        editLectureRequest({
          id: data?.id,
          formData: formData,
          action: action,
        })
      );
    }
  };

  const closeFunc = () => {
    dispatch(closeCreateLectureModel());
    setSelectedData({});
    reset();
  };
  return (
    <MainModel
      isLoading={isLoading}
      header={header}
      closeFunc={closeFunc}
      openVar={openLecture}
      buttonTitle={" حفظ التغيرات"}
      buttonFunc={handleSubmit(onSubmit)}
    >
      <form onSubmit={handleSubmit(onSubmit)}>
        <Flex
          dir="rtl"
          w="100%"
          flexWrap="wrap"
          justifyContent="space-between"
          gap="4"
        >
          <Box w="45%">
            <MainInput
              label="اسم السنتر"
              defaultValues={data.title}
              error={errors?.title?.message}
              placeholder="ادخل اسم السنتر"
              register={register}
              name="title"
            />
          </Box>

          {/* if user is super admin show subject */}
          {isSuperAdmin && (
            <Box w="100%">
              <Box w="45%">
                <FormLabel>المادة : </FormLabel>
                <Select
                  options={subjectsOptions}
                  value={
                    subjectsOptions?.find(
                      (option) =>
                        String(option.value) === String(selectedFormSubjectId)
                    ) || null
                  }
                  onChange={(option) => {
                    setValue("subject_id", option.value);
                    dispatch(getAllGroupsRequest({ subject_id: option.value }));
                  }}
                  styles={colourStyles}
                  placeholder="المادة"
                />
              </Box>
            </Box>
          )}

          <Box w="100%">
            <Box w="45%">
              <FormLabel>المجموعات : </FormLabel>
              <Select
                options={groupsOptions}
                isMulti={true}
                onChange={(data) => {
                  const selectedGroups = data.map((val) => val.value);
                  setValue("groups", selectedGroups);
                }}
                styles={colourStyles}
                placeholder="الفصول"
                defaultValue={data?.groups?.map((val) => {
                  // Handle both object format and direct value format
                  if (typeof val === 'object' && val.name && val.id) {
                    return { label: val.name, value: val.id };
                  } else if (typeof val === 'object' && val.label && val.value) {
                    return { label: val.label, value: val.value };
                  } else {
                    // If it's just an ID, find the group name from groups array
                    const group = groups?.find(g => g.id === val);
                    return group ? { label: group.name, value: group.id } : { label: 'Unknown', value: val };
                  }
                })}
              />
            </Box>
          </Box>
        </Flex>
      </form>
    </MainModel>
  );
};

export default AddLecture;
